
import * as employeesService from "@/services/employeesService";
import { StoreEmployee } from "@/models/storeModel";

// Employee operations
export const employeeOperations = {
  fetchEmployees: async (storeId?: string | null) => {
    try {
      const employees = await employeesService.fetchEmployees(
        storeId || undefined
      );

      // Convert Employee[] to StoreEmployee[]
      const storeEmployees: StoreEmployee[] = employees.map((employee) => ({
        id: employee.id,
        userId: employee.user_id || "",
        storeId: employee.store_id || "",
        firstName: employee.first_name,
        lastName: employee.last_name,
        role: employee.role as StoreEmployee["role"],
        email: employee.email || "",
        address: employee.address || "",
        createdAt: new Date(employee.created_at || Date.now()),
        updatedAt: new Date(employee.updated_at || Date.now()),
      }));

      return storeEmployees;
    } catch (error) {
      console.error("Error in fetching employees:", error);
      throw error;
    }
  },

  addEmployee: async (
    employeeData: Omit<
      StoreEmployee,
      "id" | "createdAt" | "updatedAt" | "userId"
    >
  ) => {
    try {
      const newEmployee = await employeesService.addEmployee(employeeData);
      return newEmployee;
    } catch (error) {
      console.error("Error creating employee invitation:", error);
      throw error;
    }
  },

  updateEmployeeRole: async (
    id: string,
    role: "admin" | "manager" | "staff" | "super_admin"
  ) => {
    try {
      const updatedEmployee = await employeesService.updateEmployeeRole(
        id,
        role
      );
      return updatedEmployee;
    } catch (error) {
      console.error("Failed to update employee role:", error);
      throw error;
    }
  },

  removeEmployee: async (id: string) => {
    try {
      const success = await employeesService.removeEmployee(id);
      return success;
    } catch (error) {
      console.error("Failed to remove employee:", error);
      throw error;
    }
  },
};
